export const REGION_NAMES: Record<string, string> = {
  us: 'United States',
  gb: 'United Kingdom',
  ca: 'Canada',
  au: 'Australia',
  ie: 'Ireland',
  nz: 'New Zealand',
  za: 'South Africa',
};

export const REGION_FLAGS: Record<string, string> = {
  us: '🇺🇸',
  gb: '🇬🇧',
  ca: '🇨🇦',
  au: '🇦🇺',
  ie: '🇮🇪',
  nz: '🇳🇿',
  za: '🇿🇦',
};

export const SUPPORTED_REGIONS = Object.keys(REGION_NAMES);

/**
 * Build an Apple Podcasts URL for a given iTunes ID and region.
 * US uses no region prefix.
 */
export function buildAppleUrl(itunesId: number | string, regionCode?: string): string {
  if (!regionCode || regionCode === 'us') {
    return `https://podcasts.apple.com/podcast/id${itunesId}`;
  }
  return `https://podcasts.apple.com/${regionCode.toLowerCase()}/podcast/id${itunesId}`;
}
